export function getAnalyticsExtensionConnectionIcon(connectionType: string): string {
  switch (connectionType) {
    case 'TABPY':
      return 'tabpy_new_connection.svg';
    case 'RSERVE':
    case 'RSERVE_HTTP':
      return 'rserve_new_connection.svg';
    case 'EINSTEIN_DISCOVERY':
      return 'einstein_discovery_new_connection.svg';
    case 'GENERIC_API':
      return 'analytics_extensions_api.svg';
    default:
      return 'extension.svg';
  }
}
